'use client';

import { createContext, useContext } from 'react';

/**
 * Marketing pages scroll with the document (MarketingShell flags
 * <html data-marketing-scroll> to unwind the app shell's `fixed inset-0
 * overflow-hidden` body lock — see styles/marketing.css). The header's
 * scroll-blur reads this boolean (set from window.scrollY) instead of querying
 * the DOM. MarketingShell owns the state + provider.
 */
const MarketingScrolledContext = createContext<boolean>(false);

export const MarketingScrolledProvider = MarketingScrolledContext.Provider;

export const useMarketingScrolled = (): boolean => useContext(MarketingScrolledContext);
